import {AddButton, CharacterIcon, Link, OptionButton, PageTitle} from "@/theme";
import {useApi} from "@/lib/hook";
import {Card, Col, Flex, Rate, Row, Spin, Typography} from "antd";
import style from "./style.module.scss";
import cn from "classnames/bind";
const { Text } = Typography;
export const AllRoles = () => {
    const {data: roles, isFetching} = useApi({
        route: { name: 'authorization.roles', query: {include: 'statistic'}},
        setting: {
            select: (resp) => resp.data,
        },
    });

    return (
        <>
            <PageTitle
                title={'Roles'}
                extra={(
                    <>
                        <Link
                            route={'roles.create'}
                        >
                            <AddButton>
                                Add role
                            </AddButton>
                        </Link>
                    </>
                )}
            />

            <Spin spinning={isFetching}>
                <Row gutter={[16, 16]}>
                    {roles ? roles.map(item => (
                        <Col
                            key={item.id}
                            xs={24}
                            sm={12}
                            md={8}
                            lg={6}
                            xl={6}
                        >
                            <Card>
                                <div className={style.card_head}>
                                    <div className={style.card_head_wrapper}>
                                        <div className={style.card_head_title}>
                                            {item.title}
                                        </div>
                                        <div className={style.card_head_extra}>
                                            <OptionButton
                                                trigger={'hover'}
                                            >
                                                <OptionButton.ButtonLink
                                                    route={'roles'}
                                                    query={{slug: item.name}}
                                                >
                                                    Edit
                                                </OptionButton.ButtonLink>
                                            </OptionButton>
                                        </div>
                                    </div>
                                </div>
                                <Flex
                                    justify="space-between"
                                >
                                    <Text>Users</Text>
                                    <Text>{item.statistic.user}</Text>
                                </Flex>
                                <Flex
                                    justify="space-between"
                                >
                                    <Text>Permissions</Text>
                                    <Text>{item.statistic.permission}</Text>
                                </Flex>
                                <Flex
                                    justify="space-between"
                                >
                                    <Text>Authority level</Text>
                                    <RoleRate value={item.statistic.level} />
                                </Flex>
                                <Text
                                    style={{
                                        color: '#656565',
                                        marginTop: '8px',
                                        fontSize: '12px',
                                        lineHeight: '16px',
                                    }}>
                                    {item.description}
                                </Text>
                            </Card>
                        </Col>
                    )) : null}
                </Row>
            </Spin>
        </>
    );
}

const RoleRate = ({value}) =>{
    return (
        <>
            <Rate
                className={cn(style.rate_custom, {
                    [style.fill_green]: value >= 80 && value <= 100,
                    [style.fill_green_light]: value >= 60 && value <= 80,
                    [style.fill_yellow]: value >= 40 && value <= 60,
                    [style.fill_orange]: value >= 20 && value <= 40,
                    [style.fill_red]: value >=0 && value <= 20,
                })}
                disabled
                character={<CharacterIcon />}
                defaultValue={Math.round((5 * value) / 100)}
            />
        </>
    )
}